import cn from "classnames"
import React, { useState } from "react"

import { useAppData } from "~/api/globals"

import { DesktopMenu } from "./components/DesktopMenu/DesktopMenu"
import { MobileMenu } from "./components/MobileMenu/MobileMenu"
import styles from "./index.module.css"

export const Header = ({ isMenuDark }) => {
  const [menuIsOpen, onMenuToogle] = useState(false)

  const { menu, links } = useAppData()

  const menuItems = [
    {
      title: { ru: "О компании", en: "Agency" },
      name: "about",
      submenu: [
        {
          title: links.services.title,
          href: links.services.href,
          isEn: true,
        },
        {
          title: links.process.title,
          href: links.process.href,
          isEn: false,
        },
        {
          title: links.about.title,
          href: links.about.href,
          isEn: true,
        },
        {
          title: links.awards.title,
          href: links.awards.href,
          isEn: true,
        },
        {
          title: links.blog.title,
          href: links.blog.href,
          isEn: false,
        },
        {
          title: links.reviews.title,
          href: links.reviews.href,
          isEn: true,
        },
      ],
      isEn: true,
    },
    {
      title: { ru: "Портфолио", en: "Works" },
      name: "portfolio",
      submenu: [],
      isEn: true,
    },
    {
      title: links.jobs.title,
      href: links.jobs.href,
      isEn: false,
    },
    {
      title: links.contacts.title,
      href: links.contacts.href,
      isEn: true,
    },
    // {
    //   title: links.en.title,
    //   href: links.en.href,
    //   isEn: false,
    // },
  ]

  return (
    <div
      className={cn(
        { [styles.WrapperDark]: !isMenuDark || !menuIsOpen },
        { [styles.WrapperLight]: isMenuDark || menuIsOpen },
      )}
    >
      <DesktopMenu menu={menu} menuItems={menuItems} onMenuToogle={onMenuToogle} />
      <MobileMenu menu={menu} menuItems={menuItems} onMenuToogle={onMenuToogle} />
    </div>
  )
}
